<template>
  <v-container fluid style="padding: 0px;">
    <v-card class="mx-auto pa-5" :max-width="$vuetify.breakpoint.smAndDown ? 900 : 800" outlined
      style="background: #F7F5F5; border-radius: 30px; border: 2px solid #05435B;">
      <v-row>
        <v-col class="text-center">
          <span v-if="!$vuetify.breakpoint.mobile" class="font-weight-black text-h5">Programa de Trabajos</span>
          <span v-else class="font-weight-black text-h6">Simula Programa de Trabajos</span>
        </v-col>
      </v-row>

      <!-- Campo Fecha Desde -->
      <v-row>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6" style="display: flex; align-items: center;">
          <span class="font-weight-black text-h7 mr-5">Desde</span>
          <v-menu v-model="fromDateMenu1" :close-on-content-click="false" offset-y transition="scale-transition"
            max-width="300px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="formattedDesde" placeholder="Inicio" prepend-icon="mdi-calendar" clearable dense
                outlined readonly v-on="on" style="height: 35px;"></v-text-field>
            </template>
            <v-date-picker v-model="fechaDesde" locale="es" full-width hide-header color="#05435B"
              @input="validateFechaDesde"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col v-else cols="6" style="display: flex; align-items: center;">
          <v-menu v-model="fromDateMenu1" :close-on-content-click="false" offset-y transition="scale-transition"
            max-width="300px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="formattedDesde" placeholder="Inicio" label="Desde" prepend-icon="mdi-calendar"
                dense outlined readonly v-on="on" style="height: 35px;"></v-text-field>
            </template>
            <v-date-picker v-model="fechaDesde" locale="es" full-width hide-header color="#05435B"
              @input="validateFechaDesde"></v-date-picker>
          </v-menu>
        </v-col>

        <!-- Campo Fecha Hasta -->
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6" style="display: flex; align-items: center;">
          <span class="font-weight-black text-h7 mr-5">Hasta</span>
          <v-menu v-model="fromDateMenu2" :close-on-content-click="false" offset-y transition="scale-transition"
            max-width="300px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="formattedHasta" placeholder="Fin" prepend-icon="mdi-calendar" clearable dense
                outlined readonly v-on="on" style="height: 35px;"></v-text-field>
            </template>
            <v-date-picker v-model="fechaHasta" locale="es" full-width hide-header color="#05435B"
              @input="validateFechaHasta"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col v-else cols="6" style="display: flex; align-items: center;">
          <v-menu v-model="fromDateMenu2" :close-on-content-click="false" offset-y transition="scale-transition"
            max-width="300px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="formattedHasta" label="Hasta" placeholder="Fin" prepend-icon="mdi-calendar" dense
                outlined readonly v-on="on" style="height: 35px;"></v-text-field>
            </template>
            <v-date-picker v-model="fechaHasta" locale="es" full-width hide-header color="#05435B"
              @input="validateFechaHasta"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <!-- Campos de archivos -->
      <v-row>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
          <span class="font-weight-black text-h7 mr-5">Archivo ODMs</span>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
          <v-file-input placeholder="ODMs.xlsx" clearable dense outlined style="height: 35px;" show-size
            accept=".xls,.xlsx" @change="updateFile(0, $event)"></v-file-input>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
          <v-file-input placeholder="ODMs.xlsx" label="Archivo ODMs" clearable dense outlined style="height: 35px;"
            show-size accept=".xls,.xlsx" @change="updateFile(0, $event)"></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
          <span class="font-weight-black text-h7 mr-5">Archivo SOLPEDS</span>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
          <v-file-input placeholder="SOLPEDS.xlsx" clearable dense outlined style="height: 35px;" show-size
            accept=".xls,.xlsx" @change="updateFile(1, $event)"></v-file-input>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
          <v-file-input placeholder="SOLPEDS.xlsx" label="Archivo SOLPEDS" clearable dense outlined
            style="height: 35px;" show-size accept=".xls,.xlsx" @change="updateFile(1, $event)"></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
          <span class="font-weight-black text-h7 mr-5">Archivo AVANCE INICIAL</span>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
          <v-file-input placeholder="AVANCE INICIAL.xlsx" clearable dense outlined style="height: 35px;" show-size
            accept=".xls,.xlsx" @change="updateFile(2, $event)"></v-file-input>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
          <v-file-input placeholder="AVANCE INICIAL.xlsx" label="Archivo AVANCE INICIAL" clearable dense outlined
            style="height: 35px;" show-size accept=".xls,.xlsx" @change="updateFile(2, $event)"></v-file-input>
        </v-col>
      </v-row>

      <!-- Switch -->
      <v-row>
        <v-col :cols="$vuetify.breakpoint.mobile ? 8 : 6">
          <span class="font-weight-black text-h7 mr-5">¿Incluir indicador de borrado pedido?</span>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.mobile ? 4 : 6">
          <v-switch style="margin: 0 !important; padding-top: 0px" v-model="borradoPedido" color="#05435B" hide-details
            inset :label="borradoPedido ? 'Sí' : 'No'"></v-switch>
        </v-col>
      </v-row>

      <!-- Botón -->
      <v-row :style="{ marginTop: '0px', marginBottom: $vuetify.breakpoint.smAndDown ? '10px' : '0px' }">
        <v-col cols="12" style="display: flex; justify-content: center; padding-top: 0px; ">
          <v-btn color="success" class="mt-4 rounded-button" @click="simular()">
            Simular
          </v-btn>
        </v-col>
      </v-row>
      <v-row style="margin-top: 0px;" v-if="archivoSimulado.length > 0">
        <v-spacer></v-spacer>
        <v-col cols="8">
          <span class="font-weight-black text-h8">{{ archivoSimulado[0].nombreFisico }}</span>
        </v-col>
        <v-col cols="2">
          <v-btn density="compact" @click="descargar(archivoSimulado[0].id, archivoSimulado[0].nombreFisico)">
            <v-icon style="color:#04395a">mdi-file-download-outline</v-icon>
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService'; // Ajusta la ruta según tu proyecto


export default {
  data() {
    return {
      fromDateMenu1: false,
      fromDateMenu2: false,
      fechaDesde: null,
      fechaHasta: null,
      borradoPedido: true,
      files: [null, null, null], // Archivos: [ODM, SOLPEDS, AVANCE INICIAL]
      archivoSimulado: []
    };
  },
  computed: {
    formattedDesde() {
      return this.fechaDesde
        ? new Date(this.fechaDesde + 'T00:00:00').toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        : "";
    },
    formattedHasta() {
      return this.fechaHasta
        ? new Date(this.fechaHasta + 'T00:00:00').toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        : "";
    },
    valid() {
      // Valida si las fechas están completas y los archivos son Excel
      return (
        this.fechaDesde &&
        this.fechaHasta &&
        this.files.length === 3 &&
        this.files.every(file => file && this.isExcelFile(file))
      );
    },
  },
  methods: {
    validateFechaDesde(value) {
      if (this.fechaHasta && new Date(value) > new Date(this.fechaHasta)) {
        this.fechaDesde = null;
        SwalService.alert("La fecha de inicio no puede ser mayor que la fecha de fin.");
      } else {
        this.fechaDesde = value;
      }
      this.fromDateMenu1 = false;
    },
    validateFechaHasta(value) {
      if (this.fechaDesde && new Date(value) < new Date(this.fechaDesde)) {
        this.fechaHasta = null;
        SwalService.alert("La fecha de fin no puede ser menor que la fecha de inicio.");
      } else {
        this.fechaHasta = value;
      }
      this.fromDateMenu2 = false;
    },
    updateFile(index, file) {
      // Actualiza el archivo correspondiente en el arreglo `files`
      this.files[index] = file;
    },
    isExcelFile(file) {
      // Verifica si el archivo tiene extensión válida
      const allowedExtensions = [".xls", ".xlsx"];
      const fileName = file.name.toLowerCase();
      return allowedExtensions.some(ext => fileName.endsWith(ext));
    },

    async simular() {
      this.archivoSimulado = [];
      try {
        SwalService.loading('Simulando...', 'Por favor espere.');
        debugger;
        if (this.fechaDesde == null || this.fechaHasta == null || !this.files.every(file => file !== null)) {
          SwalService.close();
          await new Promise(resolve => setTimeout(resolve, 100));
          SwalService.alert('Debe cargar todos los campos para poder continuar')
          return;
        }

        // Realizar solicitud POST al backend para autenticación
        const response = await apiService.post("/programa-trabajos/inicia-proceso", {
          fechaInicio: this.fechaDesde,
          fechaFin: this.fechaHasta,
          indicadorBorrado: this.borradoPedido,
          tipoProceso: 1,
          idProceso: null,
          idUsuario: 2
        });

        // Maneja la respuesta
        const respuesta = response.data;
        if (respuesta.success) {
          const datos = {
            archivos: [
              {
                id: null,
                nombreLogico: null,
                nombreFisico: null,
                ruta: null,
                fechaCarga: null,
                proceso: respuesta.proceso,
                tipoArchivo: 1,
              },
              {
                id: null,
                nombreLogico: null,
                nombreFisico: null,
                ruta: null,
                fechaCarga: null,
                proceso: respuesta.proceso,
                tipoArchivo: 2,
              },
              {
                id: null,
                nombreLogico: null,
                nombreFisico: null,
                ruta: null,
                fechaCarga: null,
                proceso: respuesta.proceso,
                tipoArchivo: 3,
              },
            ],
          };

          // Crear un FormData para enviar los archivos y los datos juntos
          const formData = new FormData();

          // Agregar los archivos a FormData (asegurando que los archivos sean seleccionados por el usuario)
          formData.append("files", this.files[0]); // Archivo ODMs
          formData.append("files", this.files[1]); // Archivo SOLPEDS
          formData.append("files", this.files[2]); // Archivo Avance Inicial

          // Agregar los datos serializados en formato JSON
          formData.append("datosAdjunto", JSON.stringify(datos.archivos));

          // Enviar los datos y los archivos al endpoint
          const response2 = await apiService.post("/files/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          // Manejar la respuesta de la carga de archivos
          const uploadResponse = response2.data;

          const response3 = await apiService.post("/programa-trabajos/ejecuta-script", {
            fechaInicio: this.fechaDesde,
            fechaFin: this.fechaHasta,
            indicadorBorrado: this.borradoPedido,
            idProceso: respuesta.proceso.idProceso,
            tipoProceso: 1,
            idUsuario: 2
          });

          const ejecutaScript = response3.data;
          if (ejecutaScript.success) {
            this.archivoSimulado = ejecutaScript.archivos;
            SwalService.close();
            SwalService.success('Simulación Completada', 'El archivo simulado ya se encuentra disponible para descargar');
          } else {
            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
            SwalService.error(ejecutaScript.error);
          }

        } else {
          await SwalService.close();
        }

      } catch (error) {
        SwalService.close();
        await new Promise(resolve => setTimeout(resolve, 100));
        console.log(error)
        await SwalService.error('Error al cargar datos', 'Ocurrió un problema.');
      }
    },
    async descargar(id, fileName) {
      try {
        SwalService.loading('Descargando...', 'Por favor espere.');
        await apiService.downloadFile(`/files/${id}`, fileName);
        console.log('Archivo descargado exitosamente.');
        SwalService.close();
      } catch (error) {
        console.error('Error al descargar el archivo:', error);
        SwalService.close();
        await new Promise(resolve => setTimeout(resolve, 100));
        SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
      }
    }


  },
};
</script>

<style scoped>
.v-menu__content {
  z-index: 9000 !important;
  position: absolute !important;
}

@media (max-width: 600px) {
  .v-application .pa-5 {
    padding: 5px !important;
  }
}
</style>
